import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiClient } from '../client';
import { useTenant } from '../../hooks/useTenant';
import type { TenantsResponse } from '../types';

export function useTenants() {
  const { setTenants } = useTenant();

  const query = useQuery<TenantsResponse>({
    queryKey: ['tenants'],
    queryFn: () => apiClient.getTenants(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // Update tenant context when data loads
  useEffect(() => {
    if (query.data?.tenants) {
      setTenants(query.data.tenants);
    }
  }, [query.data, setTenants]);

  return query;
}
